// Duck structure from https://github.com/alexnm/re-ducks/

import reducer from './reducer';
import * as types from './types';

export { types };

export default reducer;
